<div class="card__info card__info--primary">
  <span class="card__info__title">Upcoming Deals</span>
  <table mat-table [dataSource]="list" matSort multiTemplateDataRows>
    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'dashboard-upcoming-deals.component.address' | localise: 'Address' }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.line1Address }}
      </td>
    </ng-container>
    <ng-container matColumnDef="closingDate">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'dashboard-upcoming-deals.component.closing_date'
            | localise: 'Closing Date'
        }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.closingDate | dateApp }}
      </td>
    </ng-container>
    <ng-container matColumnDef="transactionStatus">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'dashboard.component.status_table_header' | localise: 'Status' }}
      </th>
      <td mat-cell *matCellDef="let app">
        <app-deal-status-with-color
          [dealTransactionStatus]="
            app.transactionStatus
          "></app-deal-status-with-color>
      </td>
    </ng-container>
    <ng-container matColumnDef="commission">
      <th mat-header-cell *matHeaderCellDef>
        {{
          'dashboard-upcoming-deals.component.commission'
            | localise: 'Commission'
        }}
      </th>
      <td mat-cell *matCellDef="let app">
        {{ app.agentCommissionAmount | currencyJs: { showSymbol: true } }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
